import request from '@/common/request'

class ArquivoConsultoriaService {
  getByAtualizacao(atualizacaoId) {
    return request.get(`/arquivos-consultoria/atualizacoes/${atualizacaoId}`)
  }

  uploadSped(atualizacaoId, data) {
    return request.post(`/arquivos-consultoria/upload/sped`, data, {
      params: {
        atualizacao: atualizacaoId
      }
    })
  }

  extractRegisters(atualizacaoId) {
    return request.post(
      `/arquivos-consultoria/atualizacoes/${atualizacaoId}/sped/extrair-registros`
    )
  }

  uploadXml(data) {
    return request.post(`/arquivos-consultoria/upload/xml`, data)
  }

  deleteById(arquivoConsultoriaId, atualizacaoId) {
    return request.delete(
      `/arquivos-consultoria/${arquivoConsultoriaId}/atualizacoes/${atualizacaoId}`
    )
  }
}

export default new ArquivoConsultoriaService()
